import platform from 'platform';

export default {
  name: platform.name,
  version: platform.version,
  layout: platform.layout,
  description: platform.description,
  manufacturer: platform.manufacturer,
  prerelease: platform.prerelease,
  product: platform.product,
  ua: platform.ua,
  os: {
    name: platform.os.toString(),
    family: platform.os.family,
    version: platform.os.version,
    architecture: platform.os.architecture,
  },
};
